import { FIREBASE_AUTH_ERROR_CODE } from 'shared/constants/firebase/errors';

/**
 * Shape shared by the Firebase auth errors and the axios rejections our auth
 * endpoints produce. Deliberately loose — these arrive from a `catch`.
 */
type MaybeAuthLikeError = {
    code?: string;
    message?: string;
};

const APPLE_AUTH_CANCELLATION_CODES = [
    '1000',
    '1001',
    'E_SIGNIN_CANCELLED_ERROR',
];

/** Covers both the Firebase code and the axios transport failure. */
function isNetworkUnavailableError(error: MaybeAuthLikeError): boolean {
    return (
        error?.code === FIREBASE_AUTH_ERROR_CODE.network_request_failed ||
        error?.code === 'ERR_NETWORK' ||
        error?.message === 'Network Error'
    );
}

/** The user backed out of the Apple Sign-In sheet — not a failure to report. */
function isAppleAuthCancellationError(error: MaybeAuthLikeError): boolean {
    const code = error?.code ? `${error.code}` : '';

    return APPLE_AUTH_CANCELLATION_CODES.includes(code);
}

export type { MaybeAuthLikeError };

export {
    APPLE_AUTH_CANCELLATION_CODES,
    isAppleAuthCancellationError,
    isNetworkUnavailableError,
};
